// extracted by mini-css-extract-plugin
export default {"icon":"TrashCanButton_icon__xrlK-","disabled":"TrashCanButton_disabled__qVAdL","button":"TrashCanButton_button__UeHrs"};